import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5791cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2 stick_to_top" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "d-none d-sm-none d-md-block" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = {
  key: 0,
  class: "navbar navbar-expand-sm navbar-light bg-light navbar-shadow"
}
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "navbar-nav" }
const _hoisted_10 = {
  key: 1,
  class: "nav-item dropdown"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "navbar-nav flex-grow-1 justify-content-end" }
const _hoisted_13 = {
  key: 1,
  class: "navbar-text d-none d-sm-block"
}
const _hoisted_14 = {
  key: 2,
  class: "navbar-text d-none d-sm-block"
}

import { useRoute, RouterLink } from 'vue-router';
import { h, ref, watch, computed, Component } from 'vue';

import router from '@/router';

import { APP_SETTINGS, SERVER_DATA } from '@/aux/app_configuration';
import {
  logoutTroubleReport,
  accessTokenLocalStorageSet,
  userID,
  userRole,
  //userRoleDescription,
} from '@/aux/authentication';
import { EUserRole } from '@interfaces/User';
import useDetectOutsideClick from '@/aux/componentOutsideClick';

// -- Own Vue components -- //
import CapitalizedText from '@/components/modals/CapitalizedText.vue';

// Define emits

export default /*#__PURE__*/_defineComponent({
  __name: 'NavHeader',
  emits: ['appFullScreen'],
  setup(__props) {

_useCssVars(_ctx => ({
  "3081368e": (_unref(APP_SETTINGS)('NAV_HEADER_BG_COLOR') || 'black'),
  "64d1c188": (_unref(APP_SETTINGS)('NAV_HEADER_TEXT_COLOR') || 'white')
}))



// Set default page title
const page_title = ref('Page title');

// Set watcher to change page title in header
const _route = useRoute();

watch(
  () => _route?.meta?.title,
  () => {
    page_title.value =
      (_route?.meta?.short_title as string) +
      (APP_SETTINGS('BETA_VERSION') === 'true' ? ' (Beta version)' : '');
  },
  {
    immediate: true,
  }
);

// Reference to top DOM-element
const refToTopDOMElement = ref();
const fullScreenModeAvailable = computed(() => {
  return refToTopDOMElement?.value?.requestFullscreen ? true : false;
});

// State to determine whether navbar is collapsed
const navBarCollapsed = ref(true);
const toggleNavBarCollapsed = () => {
  navBarCollapsed.value = !navBarCollapsed.value;
};

// State to determine whether dropdown menu is collapsed
const dropdownAdminCollapsed = ref(true);
const toggleDropdownAdminCollapsed = () => {
  dropdownAdminCollapsed.value = !dropdownAdminCollapsed.value;
};

//
const dropdownAdminRef = ref();

useDetectOutsideClick(dropdownAdminRef, (): void => {
  if (!dropdownAdminCollapsed.value) {
    dropdownAdminCollapsed.value = true;
  }
});

// Create log-out code
const logout = async () => {
  await logoutTroubleReport();
  router.push({ name: 'login' });
};

// Functional components
const SubNavbarItem: Component = (props, context) => {
  return h('li', {}, [
    h(
      RouterLink,
      {
        class: 'dropdown-item',
        to: { name: props.route_name },
        onClick(_event: Event) {
          toggleDropdownAdminCollapsed();
        },
      },
      () => context?.slots?.default?.()
    ),
  ]);
};

const FullScreenSymbol: Component = (_props, _context) => {
  return h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '16',
      height: '16',
      fill: 'currentColor',
      class: 'bi bi-fullscreen',
      viewBox: '0 0 16 16',
    },
    [
      h('path', {
        d: 'M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z',
      }),
    ]
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: "ps-3 pe-3 pt-1 pb-2 nav-header d-flex align-items-center flex-row-reverse gap-2",
      ref_key: "refToTopDOMElement",
      ref: refToTopDOMElement
    }, [
      _createVNode(_unref(RouterLink), { to: { name: 'home' } }, {
        default: _withCtx(() => [
          (`${_unref(SERVER_DATA).PUBLIC_FOLDER}/${_unref(APP_SETTINGS)('ATO_LOGO')}`)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: `${_unref(SERVER_DATA).PUBLIC_FOLDER}/${_unref(APP_SETTINGS)('ATO_LOGO')}`,
                style: {"max-height":"20px"},
                class: "mb-0"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(CapitalizedText, {
          text: (_unref(APP_SETTINGS)('ATO_NAME') as string),
          big_style: 'h6',
          small_style: 'small'
        }, null, 8, ["text"])
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(CapitalizedText, {
          text: page_title.value,
          big_style: 'h3',
          small_style: 'h5'
        }, null, 8, ["text"])
      ])
    ], 512),
    (_unref(accessTokenLocalStorageSet)())
      ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "navbar-toggler",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": "#navbarSupportedContent",
              "aria-controls": "navbarSupportedContent",
              "aria-expanded": "false",
              "aria-label": "Toggle navigation",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleNavBarCollapsed()))
            }, _hoisted_8),
            _createElementVNode("div", {
              class: _normalizeClass(["collapse navbar-collapse", navBarCollapsed.value ? '' : 'show']),
              id: "navbarSupportedContent"
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(RouterLink), {
                  class: "nav-link",
                  to: { name: 'fleet-overview' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Fleet Overview ")
                  ]),
                  _: 1
                }),
                (_unref(userRole)() >= _unref(EUserRole).USER)
                  ? (_openBlock(), _createBlock(_unref(RouterLink), {
                      key: 0,
                      class: "nav-link",
                      to: { name: 'create-report' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Create Report ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(userRole)() >= _unref(EUserRole).ADMIN)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["nav-link dropdown-toggle", dropdownAdminCollapsed.value ? '' : 'show']),
                        href: "#",
                        id: "navbarDropdownMenuLink",
                        role: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false",
                        onClick: _withModifiers(toggleDropdownAdminCollapsed, ["stop"])
                      }, " Admin ", 10, _hoisted_11),
                      _createElementVNode("ul", {
                        class: _normalizeClass(["dropdown-menu", dropdownAdminCollapsed.value ? '' : 'show']),
                        "aria-labelledby": "navbarDropdownMenuLink",
                        ref_key: "dropdownAdminRef",
                        ref: dropdownAdminRef
                      }, [
                        _createVNode(SubNavbarItem, { route_name: "admin-aircraft" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Aircraft ")
                          ]),
                          _: 1
                        }),
                        _createVNode(SubNavbarItem, { route_name: "admin-aircraft-type" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Aircraft types ")
                          ]),
                          _: 1
                        }),
                        _createVNode(SubNavbarItem, { route_name: "admin-user" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Users")
                          ]),
                          _: 1
                        })
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_unref(fullScreenModeAvailable))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "nav-link d-none d-sm-block",
                      href: "#!",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('appFullScreen')))
                    }, [
                      _createVNode(FullScreenSymbol)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(fullScreenModeAvailable))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, " |  "))
                  : _createCommentVNode("", true),
                _createVNode(_unref(RouterLink), {
                  class: "nav-link",
                  to: { name: 'user-profile' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(userID)()), 1)
                  ]),
                  _: 1
                }),
                (_unref(fullScreenModeAvailable))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " |  "))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  class: "nav-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (logout())),
                  href: "#!"
                }, "Sign out")
              ])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})